module.exports = __webpack_public_path__ + "static/stumbling-on-happiness-c6d199275a5bc7b7e863ec7ae5172277.jpg";